import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import QuoteProductDetail from '../../../quotes/entities/quoteProductDetail';
import { TextMosaic, TextMosaicDto, MosaicWall } from '@ami/react/core';
import ThumbBucketLocationType from '../../../quotes/entities/thumbBucketLocationType';
import ProductThumbSelectionViewWarnings from './ProductThumbSelectionViewWarnings';
import ProductExistingBucketDetailViewComponent from '../../../quotes/step3/ProductExistingBucketDetailViewComponent';
import ProductBucketQuoteProductSelectionViewComponent from '../../../quotes/review/quote-products/ProductBucketQuoteProductSelectionViewComponent';
import QuoteView from '../../../quotes/view/quoteView';

class ProductThumbSelectionViewComponent extends React.Component {
  static propTypes = {
    entity: PropTypes.instanceOf(QuoteProductDetail).isRequired,
    quote: PropTypes.instanceOf(QuoteView).isRequired,
  };

  getProductFiltered = () => {
    const { quote, entity } = this.props;
    const { products } = quote;
    return products.filter((x) => x.id === entity.bucketQuoteProductId);
  };

  render() {
    const { entity } = this.props;
    const products = this.getProductFiltered();
    const noBuckets =
      entity.bucketLocation === ThumbBucketLocationType.SameQuote &&
      (!products || products.length === 0);

    return (
      <Fragment>
        <div className="row justify-content-center text-center mb-2">
          <h5>Will the thumb be used with a bucket on this quote?</h5>
        </div>
        <div className="row text-center mt-1">
          <MosaicWall
            childrenContainerClassName="row justify-content-center"
            placeholder="Select a option.."
          >
            <TextMosaic
              data={
                new TextMosaicDto({
                  label: <div>Yes</div>,
                  selected:
                    entity.bucketLocation === ThumbBucketLocationType.SameQuote,
                  disabled: !entity.isEdit,
                })
              }
              onClick={() => {}}
              widthColumns={4}
            />
            <TextMosaic
              data={
                new TextMosaicDto({
                  label: <div>No</div>,
                  selected:
                    entity.bucketLocation ===
                    ThumbBucketLocationType.ExistingQuote,
                  disabled: !entity.isEdit,
                })
              }
              onClick={() => {}}
              widthColumns={4}
            />
          </MosaicWall>
        </div>
        {entity.bucketLocation === ThumbBucketLocationType.ExistingQuote && (
          <div className="row justify-content-center text-center mb-2">
            <h5>
              Do you have the specifications for the bucket available now?
            </h5>
          </div>
        )}
        {entity.bucketLocation === ThumbBucketLocationType.ExistingQuote && (
          <div className="row text-center mt-1">
            <MosaicWall
              childrenContainerClassName="row justify-content-center"
              placeholder="Select a option.."
            >
              <TextMosaic
                data={
                  new TextMosaicDto({
                    label: <div>Yes</div>,
                    selected: entity.existingBucketSpecsAvailable,
                    disabled: true,
                  })
                }
                onClick={() => {}}
                widthColumns={4}
              />
              <TextMosaic
                data={
                  new TextMosaicDto({
                    label: <div>No</div>,
                    selected: entity.existingBucketSpecsAvailable === false,
                    disabled: true,
                  })
                }
                onClick={() => {}}
                widthColumns={4}
              />
            </MosaicWall>
          </div>
        )}
        {!entity.existingBucketSpecsAvailable &&
          entity.existingBucketSpecsNotAvailableAcknowledgedByUserId && (
            <ProductThumbSelectionViewWarnings entity={entity} />
          )}
        {((entity.existingBucket && entity.existingBucketSpecsAvailable) ||
          (entity.bucketLocation === ThumbBucketLocationType.SameQuote &&
            !noBuckets)) && (
          <div className="hr-divider inverse">
            <h3 className="hr-divider-content hr-divider-heading">
              Bucket Specifications
            </h3>
          </div>
        )}
        {entity.bucketLocation === ThumbBucketLocationType.SameQuote &&
          !noBuckets && (
            <ProductBucketQuoteProductSelectionViewComponent
              entity={entity}
              products={products}
            />
          )}
        {entity.existingBucket && entity.existingBucketSpecsAvailable && (
          <ProductExistingBucketDetailViewComponent
            entity={entity.existingBucket}
          />
        )}
      </Fragment>
    );
  }
}

export default ProductThumbSelectionViewComponent;
